import React, {FC, useState} from "react"
import idHelper from "@irati/utils/id"
import Button from "@irati/ui/src/Button"
import Flex from "@irati/ui/src/Flex"
import {Deal} from "@irati/types"
import FormattedMessage from "@irati/utils/lang"
import {hangPromise} from "@irati/utils/promise"
import Loading from "@irati/ui/src/Loading"
import getDealCtaLocal, {LOCAL_ID} from "@irati/deals/utils/deal/getDealCtaLocal"
import {StyledSection} from "./styled/StyledSection"
import TimeLimitedDeal from "./TimeLimitedDeal"
import TTPaymentInfo from "./TTPaymentInfo"
import RPPaymentInfo from "./RPPaymentInfo"
import CashPaymentInfo from "./CashPaymentInfo"
import {OnDealSubmit} from "../../../../containers/DealInfo"
import RLOTError from "../../RLOTError"

interface Props {
  id?: string
  onSubmit: OnDealSubmit
  deal: Deal
}

const localID: Record<LOCAL_ID, string> = {
  FLEXIPERK: "perks.containers.dealImportantInfo.getFlexiPerk",
  SELECT_PERK: "perks.containers.dealImportantInfo.selectVoucher",
  PAID_PERK: "perks.containers.dealImportantInfo.getPerk",
  UNPAID_PERK: "perks.containers.dealImportantInfo.getPerk",
  REWARD: "perks.containers.dealImportantInfo.getReward",
  COMPANY_BENEFIT: "perks.containers.dealImportantInfo.getBenefit"
}

const StandardCTA: FC<Props> = ({deal, onSubmit, id}: Props) => {
  const [submit, setSubmit] = useState<Promise<any> | null>(null)

  const handleSubmit = () => {
    setSubmit(onSubmit().then(() => hangPromise()))
  }

  const key = localID[getDealCtaLocal(deal)]

  return (
    <StyledSection>
      <TimeLimitedDeal deal={deal} />
      <TTPaymentInfo deal={deal} />
      <RPPaymentInfo />
      <CashPaymentInfo deal={deal} />
      <Flex direction="column" alignItems="center">
        <Loading load={submit} useLoader={false} Error={RLOTError} />
        <Button id={idHelper("getThisPerk", {id}, {force: true})} primary large full load={submit} onClick={handleSubmit}>
          <FormattedMessage id={key} />
        </Button>
      </Flex>
    </StyledSection>
  )
}

export default StandardCTA
